
<div class="rowScreenColPhone">

	<div></div>

	<mat-spinner diameter=30 *ngIf="bLoading" />

	<button
		mat-raised-button
		color="primary"
		[disabled]="bLoading"
		(click)="showCreationDialog()"
	>
		Neue Gruppe
	</button>

</div>

<div>

	@if( !elements.length ) {
		@if( !bLoading ) {
			<div class="accNoElements">
				Keine Gruppen vorhanden
			</div>
		}
	}
	@else {

		<div class="accFilterAndAccordeon">

			<mat-form-field
				appearance="outline"
				subscriptSizing="dynamic"
				class="accFilter"
			>

				<mat-label>Filter</mat-label>
				<input
					matInput
					placeholder="Beispiel: gruppe1"
					(keyup)="onFilterChanged($event)"
				>
				<mat-icon matSuffix>search</mat-icon>

			</mat-form-field>

			<div class="accAccordeon">

				@if( !filteredElements.length ) {

					<div class="accNoElements">
						Keine Daten entspricht dem Filter
					</div>

				}	
				@else {

					<div
						class="accHeaders"
						[class.accSortIconDesc]="!sortingAsc"
					>

						<div
							class="accCell"
							[class.accActiveSorting]="sortingField == 'vgName'"
							(click)="sortColumn('vgName')"
							title="Nach Name sortieren"
						>
							<div class="accHeader">
								<span>Name</span>
								<mat-icon class="accSortIcon">
									{{ sortingField == 'vgName' ? 'arrow_downward' : 'swap_vert' }}
								</mat-icon>
							</div>
						</div>

					</div>
						
					<div class="accScrollPanel">

						@for( element of filteredElements; track element.vgId ) {

							<div
								class="accRow"
								(click)="clickOnRow( element.vgId )"
								[class.accRowActive]="expandedElementId == element.vgId"
								[id]="'elementRow_' + element.vgId"
							>
								<div class="accCell">
									{{ element.vgName }}
								</div>
							</div>

							@if( expandedElementId == element.vgId ) {

								<div
									class="accDetail"
									[@accordeonMe]
								>
									<app-calendar-group-editor
										[group]="element"
										(deleted)="onCalendarGroupDeleted(element)"
									/>
								</div>

							}

						}

					</div>

				}

			</div>

		</div>

	}

</div>


	

